import * as React from "react";
import { WidgetFrame } from "../studio/index.js";
export * from "./FormSample.jsx";
import { FormSample } from "./FormSample.jsx";
export * from "./IconSample.jsx";
import { IconSample } from "./IconSample.jsx";
export * from "./LocaleSample.jsx";
import { LocaleSample } from "./LocaleSample.jsx";
export * from "./ProductSample.jsx";
import { ProductSample } from "./ProductSample.jsx";
export { Sample as MVCSample } from "./MVCSample.jsx";
import { Sample as MVCSample } from "./MVCSample.jsx";
export { Sample as ServiceSample } from "./ServiceSample.jsx";
import { Sample as ServiceSample } from "./ServiceSample.jsx";
export * from "./HomeSample.jsx";
import { HomeSample } from "./HomeSample.jsx";
export * from "./StudioSample.jsx";
import { StudioSample } from "./StudioSample.jsx";
export { SampleRouter };
const CONTROLLER =
{
  HomeSample,
  StudioSample,
  ProductSample,
  MVCSample,
  ServiceSample,
  FormSample,
  LocaleSample,
  IconSample,
};
/**
 * Роутер по списку примеров.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru> 
 */
function SampleRouter() {
  const controller_id = new URLSearchParams(location.search)
    .get("controller") ?? "SampleIndex";
  const Controller = CONTROLLER[controller_id] ?? SampleIndex;
  return <Controller />;
}
function SampleIndex() {
  const li = [];
  for (const controller_id in CONTROLLER) {
    const Controller = CONTROLLER[controller_id];
    li.push(
      <li key={controller_id}>
        <a href={"?controller=" + controller_id}>
          {Controller.title}
        </a>
      </li>
    );
  }
  return (
    <WidgetFrame icon="grid" title={SampleIndex.title}>
      <ul>{li}</ul>
    </WidgetFrame>
  );
}

/**
 * Название примера для SampleRouter.
 * @private
 */
SampleIndex.title = "Примеры";
